(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shpflt-countdown"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initCountdown(sectionId) {
      const countdownElement = document.getElementById('countdown-' + sectionId);
      if (!countdownElement) return null;

      const endDateStr = countdownElement.getAttribute('data-end-date');
      const showSeconds = countdownElement.getAttribute('data-show-seconds') === 'true';
      
      if (!endDateStr) return null;

      const endDate = new Date(endDateStr).getTime();
      const finalMessageElement = document.getElementById('final-message-' + sectionId);
      
      function updateCountdown() {
        const now = new Date().getTime();
        const distance = endDate - now;

        if (distance < 0) {
          // Countdown finished
          if (finalMessageElement && finalMessageElement.textContent.trim() !== '') {
            countdownElement.classList.add('hidden');
            finalMessageElement.classList.add('show');
          } else {
            // Show default 0000000 if no final message
            countdownElement.classList.remove('hidden');
            const digits = countdownElement.querySelectorAll('.shpflt-countdown-digit-inner');
            digits.forEach(function(digit) {
              digit.textContent = '0';
            });
          }
          return null;
        }

        // Calculate time units
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Update days - select by label text to avoid nth-child issues with separators
        const daysUnit = Array.from(countdownElement.querySelectorAll('.shpflt-countdown-unit')).find(function(unit) {
          return unit.querySelector('.shpflt-countdown-unit-label').textContent.trim() === 'Días';
        });
        if (daysUnit) {
          const daysDigits = daysUnit.querySelectorAll('.shpflt-countdown-digit-inner');
          updateDigits(daysDigits, days, 2);
        }

        // Update hours
        const hoursUnit = Array.from(countdownElement.querySelectorAll('.shpflt-countdown-unit')).find(function(unit) {
          return unit.querySelector('.shpflt-countdown-unit-label').textContent.trim() === 'Horas';
        });
        if (hoursUnit) {
          const hoursDigits = hoursUnit.querySelectorAll('.shpflt-countdown-digit-inner');
          updateDigits(hoursDigits, hours, 2);
        }

        // Update minutes
        const minutesUnit = Array.from(countdownElement.querySelectorAll('.shpflt-countdown-unit')).find(function(unit) {
          return unit.querySelector('.shpflt-countdown-unit-label').textContent.trim() === 'Minutos';
        });
        if (minutesUnit) {
          const minutesDigits = minutesUnit.querySelectorAll('.shpflt-countdown-digit-inner');
          updateDigits(minutesDigits, minutes, 2);
        }

        // Update seconds if enabled
        if (showSeconds) {
          const secondsUnit = Array.from(countdownElement.querySelectorAll('.shpflt-countdown-unit')).find(function(unit) {
            return unit.querySelector('.shpflt-countdown-unit-label').textContent.trim() === 'Segundos';
          });
          if (secondsUnit) {
            const secondsDigits = secondsUnit.querySelectorAll('.shpflt-countdown-digit-inner');
            updateDigits(secondsDigits, seconds, 2);
          }
        }

        return true;
      }

      function updateDigits(digitElements, value, padLength) {
        const valueStr = String(value).padStart(padLength, '0');
        digitElements.forEach(function(digitEl, index) {
          const newValue = valueStr[index] || '0';
          const currentValue = digitEl.textContent.trim();
          
          if (currentValue !== newValue) {
            const digitContainer = digitEl.closest('.shpflt-countdown-digit');
            if (digitContainer) {
              digitContainer.classList.add('flip');
              setTimeout(function() {
                digitEl.textContent = newValue;
                setTimeout(function() {
                  digitContainer.classList.remove('flip');
                }, 500);
              }, 250);
            } else {
              digitEl.textContent = newValue;
            }
          }
        });
      }

      // Initial update
      updateCountdown();

      // Update every second (or every minute if seconds are disabled)
      const interval = setInterval(function() {
        const shouldContinue = updateCountdown();
        if (!shouldContinue) {
          clearInterval(interval);
        }
      }, showSeconds ? 1000 : 60000);

      return interval;
    }

    // Initialize all countdown sections on page load
    const allCountdownSections = document.querySelectorAll('[id^="countdown-"]');
    const intervals = [];
    
    allCountdownSections.forEach(function(countdownEl) {
      const sectionId = countdownEl.id.replace('countdown-', '');
      const interval = initCountdown(sectionId);
      if (interval) {
        intervals.push({ sectionId: sectionId, interval: interval });
      }
    });

    // Handle theme editor events
    document.addEventListener('shopify:section:load', function(event) {
      const section = document.querySelector('#shopify-section-' + event.detail.sectionId);
      if (section) {
        const countdownEl = section.querySelector('[id^="countdown-"]');
        if (countdownEl) {
          const sectionId = countdownEl.id.replace('countdown-', '');
          // Clear existing interval if any
          const existingIndex = intervals.findIndex(function(item) {
            return item.sectionId === sectionId;
          });
          if (existingIndex !== -1) {
            clearInterval(intervals[existingIndex].interval);
            intervals.splice(existingIndex, 1);
          }
          // Initialize new
          const interval = initCountdown(sectionId);
          if (interval) {
            intervals.push({ sectionId: sectionId, interval: interval });
          }
        }
      }
    });

    document.addEventListener('shopify:section:unload', function(event) {
      const sectionId = event.detail.sectionId;
      const index = intervals.findIndex(function(item) {
        return item.sectionId === sectionId;
      });
      if (index !== -1) {
        clearInterval(intervals[index].interval);
        intervals.splice(index, 1);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shpflt-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initFAQ(sectionElement) {
      if (!sectionElement) return null;

      const faqContainer = sectionElement.querySelector('.shpflt-faq-items');
      if (!faqContainer) return null;
      
      const accordionMode = faqContainer.getAttribute('data-accordion-mode') === 'true';
      const faqItems = faqContainer.querySelectorAll('.shpflt-faq-item');
      const eventListeners = [];
      
      function handleClick(item, question, answer) {
        return function() {
          const isActive = item.classList.contains('active');
          
          // Close all other items if accordion mode
          if (accordionMode) {
            faqItems.forEach(function(otherItem) {
              if (otherItem !== item) {
                otherItem.classList.remove('active');
                const otherQuestion = otherItem.querySelector('.shpflt-faq-question');
                const otherAnswer = otherItem.querySelector('.shpflt-faq-answer');
                if (otherQuestion) {
                  otherQuestion.setAttribute('aria-expanded', 'false');
                }
                if (otherAnswer) {
                  otherAnswer.setAttribute('aria-hidden', 'true');
                }
              }
            });
          }
          
          // Toggle current item
          if (isActive) {
            item.classList.remove('active');
            question.setAttribute('aria-expanded', 'false');
            answer.setAttribute('aria-hidden', 'true');
          } else {
            item.classList.add('active');
            question.setAttribute('aria-expanded', 'true');
            answer.setAttribute('aria-hidden', 'false');
          }
        };
      }
      
      faqItems.forEach(function(item) {
        const question = item.querySelector('.shpflt-faq-question');
        const answer = item.querySelector('.shpflt-faq-answer');
        
        if (!question || !answer) return;
        
        const clickHandler = handleClick(item, question, answer);
        question.addEventListener('click', clickHandler);
        eventListeners.push({ element: question, event: 'click', handler: clickHandler });
        
        // Initialize aria attributes
        question.setAttribute('aria-expanded', 'false');
        answer.setAttribute('aria-hidden', 'true');
      });
      
      return eventListeners;
    }

    function cleanup(eventListeners) {
      if (eventListeners && eventListeners.length > 0) {
        eventListeners.forEach(function(listener) {
          listener.element.removeEventListener(listener.event, listener.handler);
        });
      }
    }

    // Initialize all FAQ sections on page load
    const allFaqContainers = document.querySelectorAll('.shpflt-faq-items');
    const allEventListeners = [];
    
    allFaqContainers.forEach(function(container) {
      const section = container.closest('[id^="shopify-section-"]');
      if (section) {
        const listeners = initFAQ(section);
        if (listeners) {
          allEventListeners.push({ section: section, listeners: listeners });
        }
      }
    });

    // Handle theme editor events
    document.addEventListener('shopify:section:load', function(event) {
      const section = document.querySelector('#shopify-section-' + event.detail.sectionId);
      if (section && section.querySelector('.shpflt-faq-items')) {
        const listeners = initFAQ(section);
        if (listeners) {
          allEventListeners.push({ section: section, listeners: listeners });
        }
      }
    });

    document.addEventListener('shopify:section:unload', function(event) {
      const sectionIndex = allEventListeners.findIndex(function(item) {
        return item.section.id === 'shopify-section-' + event.detail.sectionId;
      });
      if (sectionIndex !== -1) {
        cleanup(allEventListeners[sectionIndex].listeners);
        allEventListeners.splice(sectionIndex, 1);
      }
    });

    document.addEventListener('shopify:block:select', function(event) {
      const section = document.querySelector('#shopify-section-' + event.detail.sectionId);
      if (section && section.querySelector('.shpflt-faq-items')) {
        const blockId = event.detail.blockId;
        const block = section.querySelector('[data-block-id="' + blockId + '"]');
        if (block) {
          const faqItem = block.closest('.shpflt-faq-item');
          if (faqItem) {
            const question = faqItem.querySelector('.shpflt-faq-question');
            const answer = faqItem.querySelector('.shpflt-faq-answer');
            if (question && answer && !faqItem.classList.contains('active')) {
              faqItem.classList.add('active');
              question.setAttribute('aria-expanded', 'true');
              answer.setAttribute('aria-hidden', 'false');
            }
          }
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
